import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CardAccessComponent, Icons, TileComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-navigation-cards',
	imports: [TileComponent, CardAccessComponent],
	templateUrl: './navigation-cards.component.html',
	styleUrl: './navigation-cards.component.scss',
})
export class NavigationCardsComponent implements OnInit {
	private trans = inject(TranslateService);
	private router = inject(Router);
	private destroyRef = inject(DestroyRef);

	public cards = this.buildCards();

	ngOnInit(): void {
		this.trans.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			this.cards = this.buildCards();
		});
	}

	private buildCards() {
		return [
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.IDENTITY_DOCUMENTS'),
				icon: 'icon-card' as Icons,
				route: '/operations/ocr',
			},
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.LIFE_TESTS'),
				icon: 'icon-user' as Icons,
				route: '/operations/pol',
			},
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.DOCUMENTATION'),
				icon: 'icon-file' as Icons,
				route: '/operations/documents',
			},
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.CONNECTIONS'),
				icon: 'icon-workflow' as Icons,
				route: '/operations/connections',
			},
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.IDENTITIES'),
				icon: 'icon-users' as Icons,
				route: '/identities',
			},
			{
				title: this.trans.instant('PANEL.NAVIGATION_CARDS.BLACKLIST'),
				icon: 'icon-x-circle' as Icons,
				route: '/blacklist',
			},
		];
	}

	public navigateTo(route: string): void {
		this.router.navigate([route]);
	}
}
